export type ViewMode = 'list' | 'grid';

type PreferenceStorage = Pick<Storage, 'getItem' | 'setItem'>;

// A new key, so choices saved while grid was the default no longer apply and
// everyone starts on the list view.
const VIEW_KEY = 'ar_dashboard_view';

export function readViewMode(storage: PreferenceStorage): ViewMode {
  try {
    return storage.getItem(VIEW_KEY) === 'grid' ? 'grid' : 'list';
  } catch {
    return 'list'; // storage blocked, e.g. by privacy settings
  }
}

export function saveViewMode(storage: PreferenceStorage, mode: ViewMode): void {
  try {
    storage.setItem(VIEW_KEY, mode);
  } catch {
    // Remembering the view is a convenience; the switch still applies.
  }
}
